/* Hero Banner Slider - behavior
   Handles slide transitions, arrow navigation, bullet dots, autoplay,
   pause-on-hover, keyboard support, and swipe on touch devices. */

(function () {
  var initializedSections = {};

  function initHeroBannerSlider(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hbs__slide'));
    if (slides.length <= 1) return; // nothing to slide between

    var dots = Array.prototype.slice.call(root.querySelectorAll('.hbs__dot'));
    var prevBtn = root.querySelector('.hbs__arrow--prev');
    var nextBtn = root.querySelector('.hbs__arrow--next');

    var currentIndex = slides.findIndex(function (s) {
      return s.classList.contains('is-active');
    });
    if (currentIndex < 0) currentIndex = 0;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;
    var timer = null;

    function goTo(index) {
      var newIndex = (index + slides.length) % slides.length;
      if (newIndex === currentIndex) return;

      slides[currentIndex].classList.remove('is-active');
      slides[currentIndex].setAttribute('aria-hidden', 'true');

      slides[newIndex].classList.add('is-active');
      slides[newIndex].removeAttribute('aria-hidden');

      if (dots[currentIndex]) {
        dots[currentIndex].classList.remove('is-active');
        dots[currentIndex].setAttribute('aria-selected', 'false');
      }
      if (dots[newIndex]) {
        dots[newIndex].classList.add('is-active');
        dots[newIndex].setAttribute('aria-selected', 'true');
      }

      currentIndex = newIndex;
    }

    function next() {
      goTo(currentIndex + 1);
    }

    function prev() {
      goTo(currentIndex - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-slide-index'), 10);
        goTo(index);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        next();
        startAutoplay();
      } else if (e.key === 'ArrowLeft') {
        prev();
        startAutoplay();
      }
    });

    // Basic touch swipe support
    var touchStartX = 0;
    var touchEndX = 0;

    root.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            next();
          } else {
            prev();
          }
          startAutoplay();
        }
      },
      { passive: true }
    );

    startAutoplay();
    initializedSections[sectionId] = true;
  }

  window.initHeroBannerSlider = initHeroBannerSlider;

  // Auto-init any sliders already on the page (non design-mode contexts)
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.hbs').forEach(function (el) {
      if (!initializedSections[el.id]) {
        initHeroBannerSlider(el.id);
      }
    });
  });
})();
